import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const productRequest = {}

productRequest.GetProductRemote = (data) => {
  return axios.post(
    AppUrls.GetProductRemote,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

productRequest.GetProductHiring = (data) => {
  return axios.post(
    AppUrls.GetProductHiring,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}


productRequest.GetProducts = (data) => {
  return axios.post(
    AppUrls.GetProducts,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}